import { RouteMap } from 'routes/router';

export const carouselRoutes = {
    dashboard: 'dashboard',
    tasks: 'tasks',
    properties: 'properties',
    manage: 'manage',
    settings: 'settings'
} as const satisfies RouteMap;
